export const routeConfig = {
  angularOrigin: window.location.origin,
  privateRoutes: [
    "/admin",
    "/scheduling",
    "/primhd",
    "/auditing",
    "/raw",
    "/update-password",
    "/extract",
    "/user-settings",
  ],
};
